export const switchButtonStyle = (isActive, disabled) => ({
    backgroundColor: isActive ? '#28a745' : '#e9ecef',
    color: isActive ? 'white' : '#6c757d',
    padding: '10px 25px',
    borderRadius: '30px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontWeight: '600',
    display: 'inline-block',
    userSelect: 'none',
    minWidth: '140px',
    textAlign: 'center',
    opacity: disabled ? 0.6 : 1,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    border: isActive ? 'none' : '1px solid #ced4da',
    letterSpacing: '0.5px'
});